
<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>{{data.message}}</mat-dialog-content>
<div [hidden]="uploadProgress < 0" class="pt-12" fxLayout="row" fxLayoutDesign="center center">
    <mat-progress-bar [mode]="mode" [value]="uploadProgress"></mat-progress-bar>
</div>